module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAICAYAAAAm06XyAAAABGdBTUEAALGPC/xhBQAAANBJREFUGBljZACC1t7Z2QwM//v//2dgBfEJgD8MTEyFNUUpU5ggCv/zEKkRpJyF6R8DF4jBCCL+///P1NY3ZzGQjgLx8QFGRsZlVUUpsUD6H9hmEMPKSCWegZFxCz6NIHmQOpB6kDqosxkYHB0d/0gLsYQCHXMAuwGMB0DyIHUwebhmkEBiYuIPVkEmP6BfTsMUgGgQHyQOkkcWR9EMkihPTv7MyMHuCXTiVbBCIA3ig8SRNYLY4ABDFwTxu6cvEvv19VckGzfb8tLMuFfY1AAAxFs53Ci0hGsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/all_icon_open_default.png
// module id = 2wnl
// module chunks = 1